export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-Regular.c9fec60f.otf";